<template>
    <div v-if="isLoading" class="loading-overlay"><p>Carregando...</p></div>
    <MensagemAlerta class="row-space" v-if="msgAlerta" :mensagem="msgAlerta" />


    <div v-show="!modoEdicao && !modoAtendimento">
        <div class="form-edit-page row-space">
            <div class="row row-space">
                <div class="form-item-codigo">
                    <label class="label-caption">Agenda</label>
                    <div class="field-label field-label-end">{{ Funcoes.formatInteger(objView.cdagenda) }}</div>
                </div>

                <div class="form-item-data">
                    <label class="label-caption">Data</label>
                    <div class="field-label field-label-center">{{ Funcoes.formatDateFromJson(objView.dtagenda) }}</div>
                </div>

                <div class="form-item-char05">
                    <label class="label-caption">Hora</label>
                    <div class="field-label field-label-center">{{ Funcoes.formatTimeFromJson(objView.hragenda) }}</div>
                </div>

                <div class="form-item">
                    <label class="label-caption">Assunto</label>
                    <div class="field-label">{{ objView.assunto }}</div>
                </div>

                <div class="form-item-char20">
                    <label class="label-caption">Tipo</label>
                    <div class="field-label">{{ objView.nmtipo }}</div>
                </div>

                <div class="form-item-char20">
                    <label class="label-caption">Situação</label>
                    <div class="field-label">{{ objView.nmstatus }}</div>
                </div>
            </div>

            
            <div class="row row-space">
                <div class="form-item">
                    <label class="label-caption">Nome</label>
                    <div class="field-label">{{ objView.nmpessoa }}</div>
                </div>
            </div>


            <div class="row-start">
                <button v-if="objView.idstatus==1" class="btn-confirm" type="button" @click="showModalConfirmacao=true">Confirmar</button>
                <button v-if="objView.idstatus==2" class="btn-confirm" type="button" @click="showModalAguardando=true">Aguardando</button>
                <button v-if="objView.idstatus==3" class="btn-confirm" type="button" @click="modoAtendimento=true">Iniciar Atendimento</button>
                <button v-if="objView.idstatus==5" class="btn-confirm" type="button" @click="abrirModalReabrir()">Reabrir</button>
                <button v-if="objView.idstatus!=9" class="btn-cancel" type="button" @click="showModalCancelamento=true">Cancelar</button>
                <button v-if="objView.idstatus==9" class="btn-confirm" type="button" @click="showModalReativar=true">Reativar</button>
                <button type="button" @click="modoEdicao=true">Alterar</button>
                <button type="button" @click="closeForm">Retornar</button>
            </div>
        </div>

        <div v-if="lsPessoas.length>0" class="form-edit-page">
            <CabecalhoFormGroup class="row-space" titulo="DEMAIS PARTICIPANTES" />
            <table>
                <thead><tr>
                    <th class="col-width-char15">CPF</th>
                    <th>Nome</th>
                    <th class="col-width-fone">Celular</th>
                    <th class="col-width-char40">Empresa</th>
                </tr></thead>
                <tbody>
                    <tr v-for="(obj, index) in lsPessoas" :key="obj.id" :class="{'even-row': index % 2 === 0, 'odd-row': index % 2 !== 0}">
                        <td class="col-width-char15 center">{{ obj.cpf }}</td>
                        <td>{{ obj.nmpessoa }}</td>
                        <td class="col-width-fone center">{{ obj.celular }}</td>
                        <td class="col-width-char40">{{ obj.empresa_nome }}</td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>

    <div>
        <ModalJustificativa
            :visible="showModalAguardando"
            @update:visible="(value) => (showModalAguardando = value)"
            @submit="salvarAguardando" />
    </div>

    <div>
        <ModalJustificativa
            :visible="showModalCancelamento"
            @update:visible="(value) => (showModalCancelamento = value)"
            @submit="salvarCancelamento" />
    </div>

    <div>
        <ModalJustificativa
            :visible="showModalConfirmacao"
            @update:visible="(value) => (showModalConfirmacao = value)"
            @submit="salvarConfirmacao" />
    </div>


    <ConfirmModal ref="confirmModal" />


    <div>
        <ModalJustificativa
            :visible="showModalReativar"
            @update:visible="(value) => (showModalReativar = value)"
            @submit="salvarReativar" />
    </div>

    <div v-if="modoAtendimento"><GabineteAgendaAtendimentoPage :idEdicao="objView.id" @close="modoAtendimento = false" @salvo="closeForm" /></div>

    <div v-if="modoEdicao"><GabineteAgendaEditPage :idEdicao="objView.id" @close="modoEdicao = false" @salvo="lerDados" /></div>
</template>

<script setup>
import { onMounted, ref } from 'vue';
import { genericPost, genericPut } from '@/funcoes/api';
import { globalStore } from '@/globals';
import { Funcoes } from '@/funcoes/utils';
import CabecalhoFormGroup from '@/components/CabecalhoFormGroup.vue';
import ConfirmModal from '@/components/modals/ConfirmModal.vue';
import GabineteAgendaAtendimentoPage from './GabineteAgendaAtendimentoPage.vue';
import GabineteAgendaEditPage from './GabineteAgendaEditPage.vue';
import MensagemAlerta from '@/components/MensagemAlerta.vue';
import ModalJustificativa from '@/components/modals/ModalJustificativa.vue';

const emit = defineEmits(['close','save']);
const props = defineProps({idView: {type: Number, default: 0}});

const confirmModal = ref(null)
const emitSave= ref(false);
const isLoading = ref(false);
const lsPessoas = ref([]);
const modoAtendimento = ref(false);
const modoEdicao = ref(false);
const msgAlerta = ref(null);
const objView = ref({});
const showModalAguardando = ref(false);
const showModalCancelamento = ref(false);
const showModalConfirmacao = ref(false);
const showModalReativar = ref(false);


async function abrirModalReabrir(){
    const confirmado = await confirmModal.value.show({
        message: "Confirma reabertura do atendimento?",
        confirmText: 'Sim',
        cancelText: 'Não'
    })
    if (confirmado){salvarReabrir()}
}


const closeForm = () => {
    if (emitSave.value){emit('save')}
    emit('close'); 
}

const lerDados = async() => {
    try{
        isLoading.value = true;
        msgAlerta.value=null;
        const req = await genericPost('/listas/gabinete_agenda', {idmunicipio: globalStore.idmunicipio, id: props.idView});
        Object.assign(objView.value, req[0]);
        if (objView.value){
            const parc = await genericPost('/listas/gabinete_pessoas', {
                idmunicipio: globalStore.idmunicipio,
                intparam1: props.idView});
            lsPessoas.value = parc;
        }
    } catch (error){msgAlerta.value = `ATENÇÃO: ${error.response?.data || error.message}`;
    }finally{isLoading.value = false;}
}


const salvarAguardando = async({justificativa}) => {
    try{
        msgAlerta.value=null;
        isLoading.value=true;
        const r = await genericPut('/cad/gabinete_agenda', {
            id: objView.value.id, 
            lgchegada: globalStore.idlogin, 
            obchegada: justificativa});
        if (r.bolok==1){
            emitSave.value=true;
            lerDados();
        }else{msgAlerta.value=r.erro}
    } catch (error){msgAlerta.value = `ATENÇÃO: ${error.response?.data || error.message}`;
    }finally{isLoading.value=false;}
}


const salvarCancelamento = async({justificativa}) => {
    try{
        msgAlerta.value=null;
        isLoading.value=true;
        const r = await genericPut('/cad/gabinete_agenda', {
            id: objView.value.id, 
            lgcancelamento: globalStore.idlogin, 
            obcancelamento: justificativa});
        if (r.bolok==1){
            emitSave.value=true;
            lerDados();
        }else{msgAlerta.value=r.erro}
    } catch (error){msgAlerta.value = `ATENÇÃO: ${error.response?.data || error.message}`;
    }finally{isLoading.value=false;}
}


const salvarConfirmacao = async({justificativa}) => {
    try{
        msgAlerta.value=null;
        isLoading.value=true;
        const r = await genericPut('/cad/gabinete_agenda', {
            id: objView.value.id, 
            lgconfirmacao: globalStore.idlogin, 
            obconfirmacao: justificativa});
        if (r.bolok==1){
            emitSave.value=true;
            lerDados();
        }else{msgAlerta.value=r.erro}
    } catch (error){msgAlerta.value = `ATENÇÃO: ${error.response?.data || error.message}`;
    }finally{isLoading.value=false;}
}

async function salvarReabrir(){
    // REABERTURA DE ATENDIMENTO FINALIZADO PARA "EM ATENDIMENTO"
    try{
        msgAlerta.value=null;
        isLoading.value=true;
        const r = await genericPut('/cad/gabinete_agenda', {
            id: objView.value.id, 
            atendimento_dhfim: null,
            idlogin: globalStore.idlogin});
        if (r.bolok==1){
            emitSave.value=true;
            lerDados();
        }else{msgAlerta.value=r.erro}
    } catch (error){msgAlerta.value = `ATENÇÃO: ${error.response?.data || error.message}`;
    }finally{isLoading.value=false;}
}

async function salvarReativar({justificativa}){
    try{
        msgAlerta.value=null;
        isLoading.value=true;
        const r = await genericPut('/cad/gabinete_agenda', {
            id: objView.value.id, 
            dhcancelamento: null,
            lgcancelamento: 0, 
            obcancelamento: justificativa});
        if (r.bolok==1){
            emitSave.value=true;
            lerDados();
        }else{msgAlerta.value=r.erro}
    } catch (error){msgAlerta.value = `ATENÇÃO: ${error.response?.data || error.message}`;
    }finally{isLoading.value=false;}
}

onMounted(lerDados);
</script>